import { render, staticRenderFns } from "./LancarNotasEletivasPage.vue?vue&type=template&id=21a7d5ce"
import script from "./LancarNotasEletivasPage.vue?vue&type=script&lang=js"
export * from "./LancarNotasEletivasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports